import { useMutation } from '@tanstack/react-query';
import { useFetch } from '@/hooks/useFetch';
import type { ErrorResponse } from '@/types/apiTypes';
import type { ClientPreferencesType, EditClientResponse } from '@/types/clientsApiTypes';

export const useUpdateClientPreferences = () => {
  const { doFetch } = useFetch<Partial<ClientPreferencesType>, EditClientResponse>();

  return useMutation<
    EditClientResponse,
    ErrorResponse<unknown>,
    { data: Partial<ClientPreferencesType>; clientId: number }
  >({
    mutationFn: ({ data, clientId }: { data: Partial<ClientPreferencesType>; clientId: number }) => {
      return doFetch(`/api/client-preferences/${clientId}`, {
        method: 'PATCH',
        body: data,
      });
    },
  });
};
